/**
 * The whole layer as a file: a signed bucket link to the object's GeoPackage. A signed file
 * link downloads without leaving the page. Nothing is converted and forint never carries the bytes.
 */
import { useState } from 'react';
import { Button, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { ApiError } from '@/api/client';
import { errorMessage } from '@/api/errors';
import type { ViewerLink } from '@/api/viewer';
import { STATUS_COLORS } from '@/theme/colors';

export interface ExportButtonProps {
  objectId: string;
  path: string;
  fetchLink: (object: string, path: string) => Promise<ViewerLink>;
}

export function ExportButton({ objectId, path, fetchLink }: ExportButtonProps) {
  const { t } = useTranslation('reports');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const run = async () => {
    setBusy(true);
    setError(null);
    try {
      const link = await fetchLink(objectId, path);
      window.location.assign(link.url);
    } catch (e) {
      setError(e instanceof ApiError ? errorMessage(e) : t('export.failed'));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Stack gap={4} className="report-export">
      <Button size="xs" variant="default" onClick={() => void run()} loading={busy}>
        {t('export.start')}
      </Button>
      {error && (
        <Text fz={11} c={STATUS_COLORS.failed.color}>
          {error}
        </Text>
      )}
    </Stack>
  );
}
